export default __webpack_public_path__ + "static/media/x.6f2235ef.png";